import type {
  ActionItem,
  IdeaActionItem,
  InsightActionItem,
  PostActionItem,
  PostDraftActionItem,
} from 'common/api/endpoints/queue';

export enum AutopilotActionType {
  create = 'create',
  merge = 'merge',
  dismiss = 'dismiss',
}

export enum AutopilotActionSourceType {
  post = 'post',
  draft = 'draft',
  idea = 'idea',
  insight = 'insight',
}

// frontend type guards for ActionItem
export const isPostActionItem = (item: ActionItem): item is PostActionItem => {
  return item.sourceType === AutopilotActionSourceType.post;
};

export const isDraftActionItem = (item: ActionItem): item is PostDraftActionItem => {
  return item.sourceType === AutopilotActionSourceType.draft;
};

export const isIdeaActionItem = (item: ActionItem): item is IdeaActionItem => {
  return item.sourceType === AutopilotActionSourceType.idea;
};

export const isInsightActionItem = (item: ActionItem): item is InsightActionItem => {
  return item.sourceType === AutopilotActionSourceType.insight;
};

/**
 * The maximum number of pending drafts to allow before we start processing feature extraction items.
 */
export const MaxPendingDrafts = 100;
